import deepmerge from 'deepmerge';
import { ENVIRONMENT_GLOBAL } from '../global_env';


export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'dev',
 production: true,
 appVersion: require('../../../package.json').version + '-dev',
  redirect: {
    host: 'https://devadmin-patchmanagement.securiton.de'
    // host: 'http://localhost:4200',
  },
  auth_L1: {
    client_id: 'patchmanagement-admin-ui',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://devaccount-my.securiton.de',

      paths: {
        prefix: '/auth/realms/Securicloud',
      },
    },
  },
  backend: {
    scope: 'spm',
    client_id: 'spm-admin-webapp-X4sGm1vQe7Az9KbP',
    endpoint: {
      host: 'https://devapi-my.securiton.de',
    },
  },
});
